/* ──────────────────────────────────────────────
 *  Libellés du tunnel tirés des traductions `@cfixe/shared` (spec Parcours § 9) :
 *  une langue est lue espace par espace, et un espace absent de la langue
 *  retombe sur le français, seule langue traduite aujourd'hui.
 * ────────────────────────────────────────────── */

import { MAPPED_TRANSLATION } from '@cfixe-monorepo/shared';

type FrenchTranslation = (typeof MAPPED_TRANSLATION)['fr-FR'];

/** Espaces de traduction lus par le tunnel. */
export type TunnelNamespace =
  | 'BOOKING_TUNNEL_LABELS'
  | 'BOOKING_TUNNEL_FLOW'
  | 'BOOKING_TUNNEL_CODES'
  | 'BOOKING_TUNNEL_NAV'
  | 'BOOKING_TUNNEL_TIMELINE';

export function tunnelTranslation<N extends TunnelNamespace>(locale: string, name: N): FrenchTranslation[N] {
  const translations = MAPPED_TRANSLATION as unknown as Record<string, Partial<FrenchTranslation> | undefined>;
  return (translations[locale]?.[name] ?? MAPPED_TRANSLATION['fr-FR'][name]) as FrenchTranslation[N];
}

/** Clés d'un espace en minuscules : `STEP_SERVICE` devient `step_service`, la clé du libellé. */
export type LowercasedLabels<T> = { [K in keyof T as Lowercase<K & string>]: string };

export const lowercaseKeys = <T extends Record<string, string>>(translation: T): LowercasedLabels<T> =>
  Object.fromEntries(
    Object.entries(translation).map(([key, value]): [string, string] => [key.toLowerCase(), value]),
  ) as LowercasedLabels<T>;
